// @flow
import * as React from 'react'
import PlaidAccount from '../lib/PlaidAccount';

export type TPlaidLinkSuccessPayload = {
  institution: { name: string, institution_id: string },
  account_id: ?string,
  public_token: string,
  accounts: Array<PlaidAccount>,
};

export const PlaidEvents = {
  open: 'OPEN',
  exit: 'EXIT',
  error: 'ERROR',
};

export type TPlaidEvents = $Values<typeof PlaidEvents>;

type TProps = {
  token: string,
  onEvent: (event: TPlaidEvents, payload: any) => void,
  onSuccess: (payload: TPlaidLinkSuccessPayload) => void,
};

function PlaidLink(props: TProps): React.Node {
  const { token, onEvent, onSuccess } = props;

  const onPostMessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (data && data.action && typeof data.action === 'string') {
        if (data.action === 'plaid_link-undefined::connected') {
          onSuccess({
            institution: data.metadata.institution,
            account_id: data.metadata.account_id,
            public_token: data.metadata.public_token,
            accounts: data.metadata.accounts.map(account => PlaidAccount.init({
              id: account.id,
              name: account.name,
              institution: data.metadata.institution,
              mask: account.mask,
              type: account.type,
              subtype: account.subtype,
            })),
          });
        }
        else onEvent(data.eventName, data.metadata);
      }
    } catch (e) {
    }
  };

  // Add event handlers
  React.useEffect(() => {
    window.addEventListener('message', onPostMessage);
    return () => window.removeEventListener('message', onPostMessage);
  }, []);

  const url = [
    'https://cdn.plaid.com/link/v2/stable/link.html',
    `?token=${token}`,
    `&origin=${window.location.origin}`,
  ].join('');

  return (
    <iframe
      id="plaid-iframe"
      border="0"
      frame="0"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      src={url}
      width="100%"
      height="100%" />
  );
}

export default PlaidLink;

